angular
	.module 'App.Repository'
	.factory 'DataRightRepository', ['BaseRepository', (BaseRepository) ->
		class DataRightRepository extends BaseRepository
			@resource = '/data_rights'
			@isRestricted = true

			getModelMap: ->
				@find('model_map').then (response) => response.data

		return new DataRightRepository
	]
